import * as _ from 'lodash'
import {
    WB_WorkspaceDimensionRow, WB_ConnectionRow
} from "../PA.Core/PAdbSchemaRows";
import {
    IConnection,
    IDimensionDataProvider,
    IHierarchyNode
} from "../PA.Reporting.Core/PA.Reporting.IF";
import {WorkspaceBO} from "./WorkspaceBO";
import {DimensionDataService} from "../PA.Reporting.Services/DimensionDataService"
import {DimensionSelector} from "../PA.Reporting.Core/DimensionSelector";


var bDebugWithMockProvider = false
import {MockDimensionDataProvider} from "../PA.UIM.Reporting/MockDimensionDataProvider";
import {JSONUtils} from "../PA.Core/Basic/JSON";


export class WorkspaceBOIDimensionSelector
    extends DimensionSelector {

    private _WorkspaceBO: WorkspaceBO
    private _WorkspaceDimensionRow: WB_WorkspaceDimensionRow


    constructor(aWS_BO: WorkspaceBO, aWS_Dimension: WB_WorkspaceDimensionRow) {

        let aDimension = {
            DimensionId: aWS_Dimension.WB_DimensionRow.cif.DIMENSION_ID,
            DimensionName: aWS_Dimension.WB_DimensionRow.cif.DIMENSION_NAME,
            DimensionTechnicalName: aWS_Dimension.WB_DimensionRow.cif.TECHNICAL_NAME,
            DimensionRenderOptions: JSONUtils.parse(aWS_Dimension.WB_DimensionRow.cif.RENDER_OPTIONS, {}),
            SortOrder: aWS_Dimension.WB_DimensionRow.cif.SORT_ORDER
        }

        let aWB_Connnection: WB_ConnectionRow = aWS_Dimension.WB_DimensionRow.WB_ConnectionRow

        let aConnection: IConnection = {
            ConnectionId: aWB_Connnection.cif.CONNECTION_ID,
            ConnectionTypeId: aWB_Connnection.cif.CONNECTION_TYPE_ID,
            ConnectionName: aWB_Connnection.cif.CONNECTION_NAME,
            ConnectionOptions: JSONUtils.parse(aWB_Connnection.cif.CONNECTION_OPTIONS, {})
        }


        let aDimensionDataProvider: IDimensionDataProvider
        if (bDebugWithMockProvider) {
            aDimensionDataProvider = new MockDimensionDataProvider()
        } else {
            aDimensionDataProvider = new DimensionDataService(aConnection, aDimension);
        }

        super(aDimension, aDimensionDataProvider, aWS_Dimension.cif.SELECTEDHIERARCHY, aWS_Dimension.cif.SELECTEDKEYS.split('|'), undefined, false, aWS_BO.WB_Workspace.WB_SALESORG_ID)

        this._WorkspaceBO = aWS_BO
        this._WorkspaceDimensionRow = aWS_Dimension

        this.OnHierarchySelectedChanged.subscribe((aDimensionSelector: WorkspaceBOIDimensionSelector) => {
            if (_.isEmpty(aDimensionSelector)) {
                return
            }
            aDimensionSelector.saveSelectedHierarchy()
        })

        this.OnHierarchyNodesSelectedChanged.subscribe((aDimensionSelector: WorkspaceBOIDimensionSelector) => {
            if (_.isEmpty(aDimensionSelector)) {
                return
            }
            aDimensionSelector.saveSelectedHierarchyNodes()
        })


    }

    // Called before BO Save.
    saveSelections() {
        this.saveSelectedHierarchy()
        this.saveSelectedHierarchyNodes()
    }

    // Called when changes are emitted
    saveSelectedHierarchy() {
        if (_.isEmpty(this.HierarchySelected)) {
            this._WorkspaceDimensionRow.cif.SELECTEDHIERARCHY = ''
        } else {
            this._WorkspaceDimensionRow.cif.SELECTEDHIERARCHY = (this.HierarchySelected && (this.HierarchySelected.HierarchyId).toString()) || ''
        }
    }

    saveSelectedHierarchyNodes() {
        if (_.isEmpty(this.HierarchyNodesSelected)) {
            this._WorkspaceDimensionRow.cif.SELECTEDKEYS = ''
        } else {
            this._WorkspaceDimensionRow.cif.SELECTEDKEYS = _.map(this.HierarchyNodesSelected, (aNode: IHierarchyNode) => {
                return aNode.NodeId
            }).join('|')
        }
    }

}
